import type * as React from "react"
import { useIntersection } from "react-use"

/**
 * Hook that tracks whether an element is visible in the viewport
 * @returns boolean | undefined - Returns:
 *   - true when the element is intersecting the viewport
 *   - false when the element is not intersecting the viewport
 *   - undefined when the element is not yet rendered or the ref is not attached
 */
export function useOnScreen(
  ref: React.RefObject<HTMLElement | null>,
  opts: IntersectionObserverInit = {}
) {
  const observerEntry = useIntersection(ref as React.RefObject<HTMLElement>, opts)
  return observerEntry?.isIntersecting
}
